import { client } from '../client';
import { Dependent } from './types/Dependent';

export const getDependentById = async (
  user_id: number,
  dependent_id: number,
  userRole?: string,
): Promise<Dependent> => {
  const prefix =
    userRole === 'CareAdvisor'
      ? '/care_advisor'
      : userRole === 'Collector'
        ? '/collector'
        : userRole === 'Admin' || userRole === 'SuperAdmin' || userRole === 'OrganizationAdmin'
          ? '/admin'
          : '';
  const { data } = await client.get(`${prefix}/users/${user_id}/dependents/${dependent_id}`);

  return data;
};
